import { render, staticRenderFns } from "./DictionaryLabel.vue?vue&type=template&id=a2720332&scoped=true"
import script from "./DictionaryLabel.vue?vue&type=script&lang=js"
export * from "./DictionaryLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2720332",
  null
  
)

export default component.exports